import { useState } from 'react';
import CheveronIcon from '@/assets/icon-cheveron.svg?react';

const CustomAccordianRow = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <div onClick={() => setOpen((o) => !o)}>
        <span>
          <CheveronIcon className={`${open ? '' : 'accordian-cheveron'}`} />
        </span>
        {title}
      </div>
      {open && <div className="accordian-content">{children}</div>}
    </div>
  );
};

export default CustomAccordianRow;
